import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import React from "react";
import { PaymentHubAPI } from "../../../providers/PaymentHubAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Loading } from "../../components/Loading";
import { Select } from "../../components/Select";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import styles from "@styles/integrations.module.scss";
import { Context } from "pages/Integrations";

export class AdyenDrawer extends React.Component {
  state = {
    loading: false,
    savingOptions: false,
    apiKey: null,
    countryCode: "BR",
    environment: "TEST",
    clientKey: null,
    hmac: null,
    merchantAccount: null,
    liveEndpointUrlPrefix: null,
    webhook_url: null,
    webhook_method: null,
    storeCode: "",
  };

  async setAsyncState(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  async componentDidMount() {
    try {
      await this.setAsyncState({ loading: true });
      const selectedEnvironment =
        await EnvironmentStorage.getSelectedEnvironment();
      await PaymentHubAPI.initAccount();
      const adyenGateway = await PaymentHubAPI.getGatewayConfiguration(
        selectedEnvironment,
        `adyen`
      );

      this.setState({
        apiKey: adyenGateway.apiKey,
        countryCode: adyenGateway.countryCode,
        environment: adyenGateway.environment,
        clientKey: adyenGateway.clientKey,
        hmac: adyenGateway.hmac,
        merchantAccount: adyenGateway.merchantAccount,
        liveEndpointUrlPrefix: adyenGateway.liveEndpointUrlPrefix,
        webhook_url: adyenGateway.webhook?.url,
        webhook_method: adyenGateway.webhook?.method,
        storeCode: adyenGateway.storeCode,
      });

      await this.setAsyncState({ loading: false });
    } catch (err) {
      await this.setAsyncState({ loading: false });
    }
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const {
        apiKey,
        clientKey,
        countryCode,
        environment,
        hmac,
        liveEndpointUrlPrefix,
        merchantAccount,
        webhook_url,
        webhook_method,
        storeCode,
      } = this.state;

      await this.setAsyncState({ savingOptions: true });

      const selectedEnvironment =
        await EnvironmentStorage.getSelectedEnvironment();
      const body = {
        apiKey: apiKey,
        countryCode: countryCode,
        environment: environment,
        clientKey: clientKey,
        hmac: hmac,
        merchantAccount: merchantAccount,
        liveEndpointUrlPrefix: liveEndpointUrlPrefix,
        webhook: {
          url: webhook_url,
          method: webhook_method,
        },
        storeCode: storeCode,
      };

      const response = await PaymentHubAPI.setGatewayConfiguration(
        selectedEnvironment,
        `adyen`,
        body
      );
      if (response.getErrors([]).length > 0) {
        alert({
          text: `Não foi possível salvar as credenciais: ${
            response.getErrors()[0]
          }`,
        });
        await this.setAsyncState({ savingOptions: false });
        return;
      }

      const paymenthub = await EnvironmentsAPI.getConfigurationsByAlias(
        selectedEnvironment,
        "paymenthub"
      );
      if (!paymenthub.gateways.adyen) {
        paymenthub.gateways.adyen = {};
      }

      paymenthub.gateways.adyen.clientKey = clientKey;
      paymenthub.gateways.adyen.environment = environment;
      const configResponse = await EnvironmentsAPI.putConfigurationsByAlias(
        selectedEnvironment,
        `paymenthub`,
        paymenthub
      );
      if (configResponse.getErrors([]).length > 0) {
        alert({
          text: `Não foi possível salvar as credenciais: ${
            response.getErrors()[0]
          }`,
        });
        await this.setAsyncState({ savingOptions: false });
        return;
      }

      await this.setAsyncState({ savingOptions: false });
      onSave && onSave();
    } catch (e) {
      console.log(e);
      await this.setAsyncState({ savingOptions: false });
    }
  }

  render() {
    const { visible, onClose } = this.props;
    const { savingOptions, loading } = this.state;
    const {
      apiKey,
      clientKey,
      countryCode,
      environment,
      hmac,
      liveEndpointUrlPrefix,
      merchantAccount,
      webhook_url,
      webhook_method,
      storeCode,
    } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Integração - Adyen"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={this.onSave.bind(this)}
            loading={savingOptions}
            disabled={loading || savingOptions}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        {loading ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Input
              design="two"
              floatLabel="Chave de API"
              value={apiKey}
              onChange={(e) => this.setState({ apiKey: e.target.value })}
            />
            <Input
              design="two"
              className="mt-20"
              floatLabel="Chave do cliente"
              value={clientKey}
              onChange={(e) => this.setState({ clientKey: e.target.value })}
            />
            <Input
              design="two"
              className="mt-20"
              floatLabel="Merchant Account"
              value={merchantAccount}
              onChange={(e) =>
                this.setState({ merchantAccount: e.target.value })
              }
            />
            <Input
              design="two"
              className="mt-20"
              floatLabel="Código da Loja"
              value={storeCode}
              onChange={(e) => this.setState({ storeCode: e.target.value })}
            />
            <Select
              design="two"
              label="País"
              onChange={(e) => this.setState({ countryCode: e.target.value })}
              className="mt-20"
              value={countryCode}
              options={[
                {
                  label: "Brasil",
                  value: "BR",
                  selected: webhook_method === "BR",
                },
                {
                  label: "Estados Unidos",
                  value: "US",
                  selected: webhook_method === "US",
                },
              ]}
            />
            <Select
              design="two"
              label="Ambiente"
              onChange={(e) => this.setState({ environment: e.target.value })}
              className="mt-20"
              value={environment}
              options={[
                {
                  label: "Produção",
                  value: "LIVE",
                  selected: webhook_method === "LIVE",
                },
                {
                  label: "Homologação",
                  value: "TEST",
                  selected: webhook_method === "TEST",
                },
              ]}
            />

            <Input
              design="two"
              className="mt-20"
              floatLabel="Chave HMAC"
              value={hmac}
              onChange={(e) => this.setState({ hmac: e.target.value })}
            />

            <Input
              design="two"
              className="mt-20"
              floatLabel="Prefixo da URL do endpoint em produção"
              value={liveEndpointUrlPrefix}
              onChange={(e) =>
                this.setState({ liveEndpointUrlPrefix: e.target.value })
              }
            />

            <Input
              design="two"
              className="mt-20"
              floatLabel="URL do webhook"
              value={webhook_url}
              onChange={(e) => this.setState({ webhook_url: e.target.value })}
            />
            <Select
              design="two"
              label="Método da requisição"
              onChange={(e) =>
                this.setState({ webhook_method: e.target.value })
              }
              className="mt-20"
              value={webhook_method}
              options={[
                {
                  label: "GET",
                  value: "GET",
                  selected: webhook_method === "GET",
                },
                {
                  label: "POST",
                  value: "POST",
                  selected: webhook_method === "POST",
                },
                {
                  label: "PUT",
                  value: "PUT",
                  selected: webhook_method === "PUT",
                },
                {
                  label: "PATCH",
                  value: "PATCH",
                  selected: webhook_method === "PATCH",
                },
              ]}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
